export default "__VITE_ASSET__pdWxtSW1__"